import React, { Component } from 'react';

import FormField from '../../style/styledComponents/FormField';
import { FiAlertCircle } from 'react-icons/fi';
import TermAndConditions from '../../Components/TermAndConditions';
import { Typography } from '@material-ui/core';
import { FaPlus, FaQuestion, FaTrashAlt } from 'react-icons/fa';
import imageCompression from 'browser-image-compression';
import Comprovante from '../../img/Comprovante_STONEID.png';
import ReactTooltip from 'react-tooltip';

class FormPos extends Component {
	constructor() {
		super();

		this.state = {
			paymentMethodDebit: false,
			paymentMethodCredit: true,
			//paymentMethodPix: false,
			//paymentMethodCash: false,
			paymentReceipt: '',
			termos: false,
			imageFile: null,
			image: '',
			errorOnField: []
		};
		this.checkField = this.checkField.bind(this);
		this.sendPaymentForm = this.sendPaymentForm.bind(this);
		this.handlePaymentMethod = this.handlePaymentMethod.bind(this);
		this.setField = this.setField.bind(this);
		this.removeImageFile = this.removeImageFile.bind(this);
		this.validateField = this.validateField.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.changeTerm = this.changeTerm.bind(this);
		this.getData = this.getData.bind(this);
	}

	checkField(name, value) {
		let fieldChecked = false;
		let checkField = {
			paymentReceipt: /^([a-z0-9]){14}$/i
		};

		if (checkField[name]) {
			if (checkField[name].test(value)) {
				fieldChecked = true;
			}
		} else {
			if (name === 'termos') {
				fieldChecked = value;
			} else if (name === 'imageFile' && value === null) {
				fieldChecked = false;
			} else {
				fieldChecked = true;
			}
		}

		return fieldChecked;
	}

	sendPaymentForm() {
		let inputData = this.state;
		let error = false;
		let errObj = {};
		for (var fieldName in inputData) {
			if (!this.checkField(fieldName, inputData[fieldName])) {
				if (fieldName === 'paymentReceipt') {
					error = true;
					if (inputData[fieldName] === '') {
						errObj = {
							...errObj,
							[fieldName]: 'Insira o código STONEID presente no comprovante.'
						};
					} else {
						errObj = {
							...errObj,
							[fieldName]: 'Numero do STONEID inválido.'
						};
					}
				}

				if (fieldName === 'termos') {
					error = true;
					errObj = {
						...errObj,
						[fieldName]: 'É necessário aceitar os termos para continuar.'
					};
				}

				if (fieldName === 'imageFile') {
					error = true;
					errObj = {
						...errObj,
						[fieldName]: 'É necessário anexar uma foto do comprovante.'
					};
				}
			}
		}

		const hasError = error;
		this.props.notSend();
		if (!hasError) {
			this.props.onSend();
		} else {
			this.setState({ errorOnField: errObj });
		}
	}

	handlePaymentMethod(e) {
		this.setState(
			{
				paymentMethodDebit:
					e.target.name === 'debito'
						? e.target.checked
						: e.target.name === 'credito'
						? !e.target.checked
						: false,
				paymentMethodCredit:
					e.target.name === 'credito' ? e.target.checked : !e.target.checked
				//paymentMethodPix: e.target.name === 'pix' ? e.target.checked : false
			},
			() => {
				this.props.isCompleted(!this.state.termos);
			}
		);
	}

	setField(e) {
		this.setState(
			{
				paymentReceipt: e.target.value
			},
			() => {
				this.props.isCompleted(!this.state.termos);
			}
		);
		this.validateField(e, e.target.name);
	}

	setImageFile = e => {
		this.clearErrorOnFocus('imageFile');
		const imageFile = e.target.files[0];
		e.target.value = null;

		const options = {
			maxSizeMB: 1,
			maxWidthOrHeight: 1920,
			useWebWorker: true
		};
		if (imageFile.type === 'application/pdf') {
			this.setState(
				{
					imageFile: imageFile
				},
				() => {
					this.props.isCompleted(!this.state.termos);
				}
			);

			let reader = new FileReader();
			reader.onload = event => {
				this.setState({
					image: event.target.result
				});
			};
			reader.readAsDataURL(imageFile);
		} else {
			imageCompression(imageFile, options)
				.then(compressedFile => {
					this.setState(
						{
							imageFile: compressedFile
						},
						() => {
							this.props.isCompleted(!this.state.termos);
						}
					);

					let reader = new FileReader();
					reader.onload = event => {
						this.setState({
							image: event.target.result
						});
					};
					reader.readAsDataURL(compressedFile);
				})
				.catch(function(error) {
					console.log(error.message);
				});
		}
	};

	removeImageFile() {
		this.setState(
			{
				imageFile: null
			},
			() => {
				this.props.isCompleted(!this.state.termos);
			}
		);
	}

	validateField(e, field) {
		let errorMsgs = {
			paymentReceipt: 'Número do STONEID inválido.'
		};
		let errorEmptyMsgs = {
			paymentReceipt: 'Insira o código STONEID presente no comprovante.'
		};
		const value = e.target.value;

		var checkField = {
			paymentReceipt: /^([a-z0-9]){14}$/i
		};

		if (!checkField[field].test(value)) {
			if (value === '') {
				this.setState({
					errorOnField: {
						...this.errorOnField,
						[field]: errorEmptyMsgs.paymentReceipt
					}
				});
			} else {
				this.setState({
					errorOnField: {
						...this.errorOnField,
						[field]: errorMsgs.paymentReceipt
					}
				});
			}
		} else {
			this.clearErrorOnFocus(field);
		}
	}

	clearErrorOnFocus(field) {
		this.setState({
			errorOnField: {
				...this.state.errorOnField,
				[field]: null
			}
		});
	}

	changeTerm(e) {
		this.clearErrorOnFocus('termos');
		const isChecked = this.state.termos ? true : false;
		this.setState(
			{
				termos: e.target.checked,
				errorMsg: isChecked
			},
			() => {
				this.props.isCompleted(isChecked);
			}
		);
	}

	getData() {
		let inputData = this.state;
		let dataSend = {};

		for (var fieldName in inputData) {
			if (this.checkField(fieldName, inputData[fieldName])) {
				dataSend[fieldName] = inputData[fieldName];
			} else {
				dataSend[fieldName] = undefined;
			}
		}

		return dataSend;
	}

	fileData = () => {
		if (this.state.imageFile) {
			return (
				<Typography>
					{this.state.imageFile.name}{' '}
					<FaTrashAlt
						size={17}
						style={{ color: 'gray', cursor: 'pointer' }}
						onClick={() => {
							this.removeImageFile();
						}}
					/>{' '}
				</Typography>
			);
		}
	};

	render() {
		this.props.onDataPos(this.getData());
		const { signatureType } = this.props;

		if (this.props.posPayment) {
			this.sendPaymentForm();
		}
		let { CmDrConsulta } = this.props;
		return (
			<>
				<FormField>
					<FormField className='form-terms'>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div style={{ marginRight: 20, width: '45%' }}>
								<label className='switch'>
									<input
										checked={this.state.paymentMethodCredit}
										type='checkbox'
										required
										name='credito'
										id='credito'
										onChange={this.handlePaymentMethod}
									/>
									<span className='slider round'></span>
									<span>Cartão de Credito</span>
								</label>
							</div>
							<div style={{ marginRight: 20, width: '45%' }}>
								<label className='switch'>
									<input
										checked={this.state.paymentMethodDebit}
										type='checkbox'
										required
										name='debito'
										id='debito'
										onChange={this.handlePaymentMethod}
									/>
									<span className='slider round'></span>
									<span>Cartão de Debito</span>
								</label>
							</div>
							{/* <div style={{ marginRight: 20, width: '10%' }}>
								<label className='switch'>
									<input
										checked={this.state.paymentMethodPix}
										type='checkbox'
										required
										name='pix'
										id='pix'
										onChange={this.handlePaymentMethod}
									/>
									<span className='slider round'></span>
									<span>PIX</span>
								</label>
							</div> */}
						</div>
					</FormField>
				</FormField>
				<FormField>
					<div style={{ height: 65 }}>
						<input
							maxLength={14}
							value={this.state.paymentReceipt}
							type='text'
							className='form-control'
							required
							id='paymentReceipt'
							name='paymentReceipt'
							onChange={this.setField}
							onFocus={() => this.clearErrorOnFocus('paymentReceipt')}
							onBlur={e => {
								this.validateField(e, 'paymentReceipt');
							}}
						/>
						<label
							htmlFor='paymentReceipt'
							className={this.state.paymentReceipt === '' ? 'subscriber' : ''}>
							Digitar o STONEID
							<button className='btn-cvv' data-tip data-for='comprovante'>
								<FaQuestion size={8} color={'#FFF'} />
							</button>{' '}
						</label>
						{this.state.errorOnField.paymentReceipt && (
							<div className='error-msg'>
								<FiAlertCircle size={13} />
								<small className='credit-card-error'>
									{this.state.errorOnField.paymentReceipt}
								</small>
							</div>
						)}
					</div>
				</FormField>
				<FormField>
					<ReactTooltip
						id='comprovante'
						place='bottom'
						effect='solid'
						className='imageTooltip'>
						<img src={Comprovante} />
					</ReactTooltip>
				</FormField>
				<FormField>
					<input
						type='file'
						id='imageFile'
						name='imageFile'
						accept='image/*, application/pdf'
						onChange={this.setImageFile}
						style={{ display: 'none' }}
					/>
					<label htmlFor='imageFile' className='button-add-file'>
						{' '}
						<FaPlus size={18} />
						<strong> Adicionar comprovante de pagamento</strong>{' '}
					</label>
					{this.state.errorOnField.imageFile && (
						<div className='error-msg'>
							<FiAlertCircle size={13} />
							<small className='credit-card-error'>
								{this.state.errorOnField.imageFile}
							</small>
						</div>
					)}
					{this.fileData()}
				</FormField>
				{/* data-cy='btn-slider' é ultilazada para selecionar o botão de confirmação de Termos, condições do produto e politica de privacidade em  testes desenvolvidos no cypress*/}
				<FormField>
					<FormField data-cy='btn-slider' className='form-terms'>
						<TermAndConditions
							changeTerm={this.changeTerm}
							cmDrConsulta={CmDrConsulta.data}
						/>
						{this.state.errorOnField.termos && (
							<div className='error-msg'>
								<FiAlertCircle size={13} />
								<small className='credit-card-error'>
									{this.state.errorOnField.termos}
								</small>
							</div>
						)}
					</FormField>
				</FormField>
			</>
		);
	}
}
export default FormPos;
